import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import OnboardingForm from '../components/Onboarding';

const OnboardingFormPage = () => {
  return (
    <>
      <Header />
      <OnboardingForm />
      <Footer onOpenModal={() => {}} />
    </>
  );
};

export default OnboardingFormPage;